document.addEventListener('DOMContentLoaded', function() {
    var announcementBar = document.querySelector('.announcement');
    var header = document.querySelector('.header');
    if( announcementBar && header ) {
        window.addEventListener('scroll', function() {
            var scrollPosition = window.scrollY;
            var scrollEnabled = announcementBar ? announcementBar.dataset.scrollEnabled : null;
            var scrollDistance = announcementBar ? announcementBar.dataset.scrollDistance : null;
    
            // if( scrollEnabled ){
                if (scrollPosition >= scrollDistance) {
                    announcementBar.classList.add('scrolling');
                    header.classList.add('scrolling');
                }
            // }else{
            //     announcementBar.classList.add('fixed');
            //     header.classList.add('fixed');
            // }
        });   
    }
});